import Button from 'molecules/Button';
import RichText from 'molecules/RichText';

import styles from 'components/TableMarque/tablemarque.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { TableMarqueProps } from 'components/TableMarque/config';
import type { FC } from 'react';

const TableMarque: FC<TableMarqueProps> = ({ content, table, footerNote }) => {
  const reports = table?.reports ?? [];

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        {content?.heading && (
          <div className={styles.heading}>
            {content.heading}
            <sup>{content?.superScript}</sup>
          </div>
        )}
        {content?.callToAction?.label && <Button {...content?.callToAction} className={styles.darkArrow} />}
        <p>&nbsp;</p>
        {table && (
          <table>
            <tbody>
              <tr>
                {isNonEmptyArray(table.headings) &&
                  table.headings.map((title, yindex) => <th key={yindex}>{title.heading}</th>)}
              </tr>
              {reports?.map((report, index) => (
                <tr key={index}>
                  {report.title && (
                    <td>
                      {report.title}
                      &nbsp;
                      {report.subtitle && <span className={styles.subtitle}>{report.subtitle}</span>}
                    </td>
                  )}
                  {report.profits?.split(',').map((profit, yIndex) => (
                    <td key={yIndex}>${Number(profit).toLocaleString()}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        {footerNote && (
          <div className={styles.footerNotes}>
            <RichText content={footerNote} />
          </div>
        )}
        <p>&nbsp;</p>
      </div>
    </div>
  );
};

export default TableMarque;
